import { getCachedMembership } from '../trip.slice';
import { useAppSelector } from 'src/app/store/hooks';
import type { MembershipRead } from 'src/common/external/bambi-api/bambiApi';

export function CreatedByCell({ id }: { id: string | null }) {
  const cachedMembership = useAppSelector((state) =>
    getCachedMembership(state, id || '')
  ) as MembershipRead | undefined;

  if (!cachedMembership) {
    return <>Unknown</>;
  }

  return (
    <>
      {cachedMembership.first_name} {cachedMembership.last_name}
    </>
  );
}
